<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitação de procedimento cirúrgico"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form
                    ref="RkmFormProcedimentoCirurgico"
                    show-legend
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :repository="repositories.procedimentoCirurgico"
                                :request-query-string-params="requestQueryStringParams"
                                :search-fields="fields.autocomplete.procedimentoCirurgico"
                                :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                                :validations="validations.procedimentoCirurgico"
                                label="Procedimento cirúrgico"
                                v-model="model.procedimentoCirurgico"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-button
                                :label="false"
                                @click="include"
                                color="primary"
                            >
                                Incluir
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="model.procedimentosCirurgicos"
                                hide-filters
                                hide-pagination
                            >
                                <template v-slot:cell(procedimentoCirurgico)="{item}">
                                    {{`${formatProcedimento(item.codigo)} - ${item.nome}`}}
                                </template>

                                <template v-slot:cell(actions)="{index}">
                                    <rkm-button
                                        @click="destroy(index)"
                                        color="danger"
                                        small
                                        title="Excluir"
                                    >
                                        <rkm-icon icon="trash" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>

                <rkm-form ref="RkmForm">
                    <rkm-row class="mt-2">
                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :repository="repositories.geral.ciap"
                                :request-query-string-params="{
                                    sexo_id: data.additionals.paciente.sexoId,
                                    show_all: true,
                                }"
                                :search-fields="fields.autocomplete.ciap"
                                :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                                @select="handleCiapSelect"
                                label="CIAP 2"
                                v-model="model.ciap"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>

                        <rkm-col cols="12" v-if="!model.sugestao">
                            <rkm-form-input-autocomplete
                                :repository="repositories.cid"
                                :request-query-string-params="{
                                    ciap_id: model.ciap ? model.ciap.id : null,
                                    sexo: data.additionals.paciente.sexoIdentificador,
                                }"
                                :results-limit= "20"
                                :search-fields="fields.autocomplete.cid"
                                :text-field="(item) => `${item.codigo} - ${item.nome}`"
                                label="CID 10"
                                v-model="model.cid"
                            >

                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        <rkm-form-radio-group
                                            v-model="model.sugestao"
                                            :disabled="data.cidSugestao.length === 0"
                                        >
                                            <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                            <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                        </rkm-form-radio-group>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input-autocomplete>
                        </rkm-col>

                        <rkm-col cols="12" v-else>
                            <rkm-form-select
                                :options="data.cidSugestao"
                                label="CID 10"
                                show-default-option
                                text-field="codigoNome"
                                v-model="model.cidId"
                                value-field="id"
                            >

                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        <rkm-form-radio-group v-model="model.sugestao">
                                            <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                            <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                        </rkm-form-radio-group>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-select>
                        </rkm-col>
                    </rkm-row>

                    <BoxClassificacaoRisco :data="classificacaoRiscoData" :encaminhamento="true" />

                    <BoxAntropometria
                        :data="{form: data.objetivoForm, model: data.objetivoModel}"
                        :hidden-fields="['perimetroPanturrilha', 'perimetroCefalico', 'imc']"
                        :required="model.procedimentosCirurgicos.some(exame => exame.exigirPesoAlturaCircunferencia)"
                    />

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativa"
                                label="Justificativa do procedimento"
                                rows="8"
                                v-model="model.justificativa"
                                maxlength="5000"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.observacao"
                                label="Observações"
                                rows="4"
                                v-model="model.observacao"
                                maxlength="1500"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxClassificacaoRisco from '@/components/ambulatorio/components/classificacao-risco/Index'
import BoxAntropometria from '@/components/ambulatorio/components/antropometria/Index'

// Mixins.
import {formats, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {BoxClassificacaoRisco, BoxAntropometria},
    computed: {
        requestQueryStringParams() {
            return {
                paciente_id: this.data.additionals.paciente.id,
            }
        },
        validations() {
            return {
                procedimentoCirurgico: {required: true},
                justificativa: {
                    required: true,
                    max: 5000,
                },
                observacao: {max: 1500},
            }
        },
        classificacaoRiscoData() {
            return {
                form: this.data.form.solicitacaoProcedimentoCirurgico,
                model: this.model
            }
        }
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            procedimentoCirurgico: this.getConectaSusRepository('parametrizacao.procedimentoCirurgico'),
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        fields: {
            autocomplete: {
                cid: [
                    {key: 'codigo', searchable: true},
                    {key: 'nome', searchable: true},
                ],
                ciap: [
                    {key: 'geral_ciap.codigo', searchable: true},
                    {key: 'geral_ciap.descricao', searchable: true},
                ],
                procedimentoCirurgico: [
                    {key: 'procedimento_cirurgico.procedimento_codigo', searchable: true},
                    {key: 'procedimento_cirurgico.nome', searchable: true},
                ],
            },
            table: [
                {key: 'procedimentoCirurgico', label: 'Procedimento cirúrgico', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        item: null,
        model: {
            procedimentoCirurgico: null,
            cid: null,
            cidId: null,
            ciap: null,
            classificacaoRiscoId: null,
            justificativa: null,
            observacao: null,
            procedimentosCirurgicos: [],
            sugestao: false,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {

            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.model.sugestao = this.data.cidSugestao.length > 0

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                cid: this.item.cid,
                cidId: this.data.cidSugestao.length > 0 ? this.item.cid.id : null,
                ciap: this.item.ciap,
                classificacaoRiscoId: this.item.classificacaoRiscoId,
                justificativa: this.item.justificativa,
                observacao: this.item.observacao,
                procedimentosCirurgicos: this.item.procedimentosCirurgicos,
                sugestao: false,
            })
        },
        include() {
            this.$refs.RkmFormProcedimentoCirurgico.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.procedimentosCirurgicos.find(pc => pc.id === this.model.procedimentoCirurgico.id)) {
                        this.showValidationNotification('O procedimento cirúrgico já foi incluído.')
                        return
                    }

                    this.model.procedimentosCirurgicos.push({
                        id: this.model.procedimentoCirurgico.id,
                        codigo: this.model.procedimentoCirurgico.codigo,
                        nome: this.model.procedimentoCirurgico.nome,
                        complexidade: this.model.procedimentoCirurgico.complexidade,
                        exigirPesoAlturaCircunferencia: this.model.procedimentoCirurgico.exigirPesoAlturaCircunferencia,
                    })

                    this.resetFormProcedimentoCirurgico()
                })
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento cirúrgico?', async () => {
                this.model.procedimentosCirurgicos.splice(index, 1)
            })
        },
        resetFormProcedimentoCirurgico() {
            this.model.procedimentoCirurgico = null
            this.$nextTick().then(() => this.$refs.RkmFormProcedimentoCirurgico.resetValidator())
        },
        store() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            this.data.model.solicitacoesProcedimentosCirurgicos.push({
                cid: cid,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                classificacaoRiscoId: this.model.classificacaoRiscoId,
                classificacaoRiscoDescricaoEncaminhamento: this.data.form.solicitacaoProcedimentoCirurgico.classificacoesRisco
                    .find(c => c.id === this.model.classificacaoRiscoId).descricaoEncaminhamento,
                justificativa: this.model.justificativa,
                observacao: this.model.observacao,
                procedimentosCirurgicos: this.model.procedimentosCirurgicos,
            })
        },
        update() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            Object.assign(this.item, {
                cid: cid,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                classificacaoRiscoId: this.model.classificacaoRiscoId,
                classificacaoRiscoDescricaoEncaminhamento: this.data.form.solicitacaoProcedimentoCirurgico.classificacoesRisco
                    .find(c => c.id === this.model.classificacaoRiscoId).descricaoEncaminhamento,
                justificativa: this.model.justificativa,
                observacao: this.model.observacao,
                procedimentosCirurgicos: this.model.procedimentosCirurgicos,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.validateCidCiap()
                    if (this.errorCidCiap) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: this.errorCidCiap
                        })
                    } else if (this.model.procedimentosCirurgicos.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É necessário incluir ao menos um procedimento cirúrgico para realizar a solicitação.'
                        })
                    } else {
                        if (this.item) {
                            this.update()
                        } else {
                            this.store()
                        }

                        this.$refs.RkmModal.hide()
                    }
                })
        },
        resetForm() {
            this.model.procedimentoCirurgico = null
            this.model.cid = null
            this.model.cidId = null
            this.model.ciap = null
            this.model.classificacaoRiscoId = null
            this.model.justificativa = null
            this.model.observacao = null
            this.model.procedimentosCirurgicos = []
            this.model.sugestao = false
        },
        validateCidCiap() {
            this.errorCidCiap = ''

            const cid = this.model.sugestao ? this.model.cidId : this.model.cid

            if (!cid && !this.model.ciap) {
                this.errorCidCiap = 'Deve ser preenchido o campo CID e/ou o campo CIAP'
            }
        },
        handleCiapSelect(value) {
            if (value.cidId) {
                this.model.cid = {
                    id: value.cidId,
                    codigo: value.cidCodigo,
                    nome: value.cidNome,
                }

                this.model.sugestao = false
            }
        },
    },
    mixins: [formats, object, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>